import { SharedCostRuleComponent } from '../shared-cost-rule.component';
import { SCRFocusStrategy } from './scr-focus-strategy.interface';
import { SharedCostRuleFieldType } from 'app/shared/types/shared-cost-rule.interface';

export class SCRInitStateFocusStrategy implements SCRFocusStrategy {
  componentInstance: SharedCostRuleComponent;

  constructor(componentInstance: SharedCostRuleComponent) {
    this.componentInstance = componentInstance;
  }

  activate() {
    this.componentInstance.currentFocusStrategy = this;
    this.componentInstance.focusedFieldType = null;
    this.componentInstance.focusedSegmentIndex = -1;
    this.componentInstance.focusedElement = null;
  }

  moveFocus(isForward: boolean) {
    const { focusStrategies } = this.componentInstance;
    if (isForward) {
      focusStrategies[SharedCostRuleFieldType.Budget].activate();
    } else {
      focusStrategies[SharedCostRuleFieldType.Status].activate();
    }
  }

  selectElement() {
    // shouldn't be implemented
  }

  unselectElement() {
    // shouldn't be implemented
  }
}
